import React, { useCallback, useState } from "react";
import assest from "../../../json/assest";
import styles from "../../../styles/components/video.module.scss";
import { Box } from "@mui/system";
import { Button } from "@mui/material";
import ButtonDisableWrapper from "./ButtonDisableWrapper";
import { updateVideoDetails } from "../../../api/functions/video.api";
import { useMutation } from "react-query";
import VideoRejectionModal from "./VideoRejectionModal";
import VideoDeleteModal from "./VideoDeleteModal";
import VideoWebsiteModal from "./VideoWebsiteModal";
export const disableStatuses = [1, 2, 4, 5];

const BuyerHandleVideo = ({ data, handleUpdate }) => {
  const { status } = data;
  const [showReject, setShowReject] = useState(false);
  const [showWebsite, setShowWebsite] = useState(false);
  const handleCloseRejectModal = useCallback(() => {
    setShowReject(false);
  }, []);
  const [showDelete, setShowDelete] = useState(false);
  const [showDeleteProceed, setShowDeleteProceed] = useState(false);

  const handleCloseDeleteModal = useCallback(() => {
    setShowDelete(false);
  }, []);
  const handleCloseDeleteProceedModal = useCallback(() => {
    setShowDeleteProceed(false);
  }, []);
  const handleCloseWebsiteModal = useCallback(() => {
    setShowWebsite(false);
  }, []);
  return (
    <>
      <VideoRejectionModal
        open={showReject}
        onClose={handleCloseRejectModal}
        handleUpdate={handleUpdate}
        data={data}
      />
      <VideoWebsiteModal
        open={showWebsite}
        onClose={handleCloseWebsiteModal}
        handleUpdate={handleUpdate}
        buttonText={"Proceed"}
        modalHeaderText={"Why should this video be posted on Website Only?"}
        data={data}
      />
      <VideoDeleteModal
        open={showDelete}
        open2={showDeleteProceed}
        onClose={handleCloseDeleteModal}
        onClose2={handleCloseDeleteProceedModal}
        handleUpdate={handleUpdate}
        data={data}
        buttonText={"Proceed"}
        modalHeaderText={"Why would you like to delete this video?"}
        setShowDeleteProceed={setShowDeleteProceed}
      />
      <Box className={styles.btnWrapper}>
        <Box className={styles.buttonGroup}>
          <Button
            className={`${styles.post}`}
            onClick={() => handleUpdate(1)}
            disabled={
              status == 1 || disableStatuses.includes(status) ? true : false
            }
          >
            <ButtonDisableWrapper index={1} status={data.status} />
            <img src={assest.postIcon} width={14} height={14} alt="" /> Post Everywhere
          </Button>
          <Button
            disabled={
              status == 5 || disableStatuses.includes(status) ? true : false
            }
            className={`${styles.website}`}
            onClick={() => setShowWebsite(true)}
          >
            <ButtonDisableWrapper index={5} status={data.status} />
            <img src={assest.websiteIcon} width={14} height={14} alt="" />{" "}
            Website Only
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default BuyerHandleVideo;
